import { render, staticRenderFns } from "./AccuracyTotalTradesRenderer.vue?vue&type=template&id=2e700058&"
import script from "./AccuracyTotalTradesRenderer.vue?vue&type=script&lang=js&"
export * from "./AccuracyTotalTradesRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports